<app-page-header
  title="Vertriebler verwalten"
  subtitle="Suche und verwalte alle Vertriebler"
  icon="groups"
  variant="gradient">
</app-page-header>

<!-- Search Field (optional, if you have filtering) -->
<!--
<div class="apple-container apple-slide-up">
  <div class="apple-search-card apple-card">
    <mat-form-field appearance="outline" class="apple-search-field">
      <mat-label>Suche nach Vertriebler</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Name, Email..." />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>
-->

<div class="apple-container">
  <div class="apple-sales-users-table-card apple-card">
    <table mat-table [dataSource]="(salesUsers$ | async) || []" class="apple-sales-users-table">
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="global-table-header-cell">Name</th>
        <td mat-cell *matCellDef="let user" class="global-table-cell">{{ user.user?.firstName }} {{ user.user?.lastName }}</td>
      </ng-container>
      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef class="global-table-header-cell">Email</th>
        <td mat-cell *matCellDef="let user" class="global-table-cell">{{ user.user?.email }}</td>
      </ng-container>
      <!-- Coins Total Column -->
      <ng-container matColumnDef="totalCoins">
        <th mat-header-cell *matHeaderCellDef class="global-table-header-cell">Coins (Total)</th>
        <td mat-cell *matCellDef="let user" class="global-table-cell">{{ user.totalCoins }}</td>
      </ng-container>
      <!-- Coins Current Column -->
      <ng-container matColumnDef="currentCoins">
        <th mat-header-cell *matHeaderCellDef class="global-table-header-cell">Coins (Aktuell)</th>
        <td mat-cell *matCellDef="let user" class="global-table-cell">{{ user.currentCoins }}</td>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="global-table-header-cell">Aktionen</th>
        <td mat-cell *matCellDef="let user" class="global-table-cell">
          <button mat-flat-button color="primary" class="apple-details-btn" (click)="openAddCoinsDialog(user)">
            <mat-icon>add</mat-icon> Coins vergeben
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['name', 'email', 'totalCoins', 'currentCoins', 'actions']" class="apple-table-header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: ['name', 'email', 'totalCoins', 'currentCoins', 'actions']" class="apple-table-row"></tr>
    </table>
    <div *ngIf="(salesUsers$ | async)?.length === 0" class="empty-state">
      Keine Vertriebler gefunden.
    </div>
  </div>
</div>
<button mat-flat-button color="primary" [routerLink]="['/admin/sales-users/history']">
  <mat-icon class="order-back-icon">history</mat-icon>
  Transaktionshistorie
</button>
<button mat-flat-button color="primary" style="width: 100%; margin-top: 8px;" [routerLink]="['/admin']">
  <mat-icon class="order-back-icon">arrow_back</mat-icon>
  Zurück
</button>